import { Component, OnInit, Input } from '@angular/core';
import { Installation } from 'src/app/model/installation/installation.model';

@Component({
  selector: 'app-installation-statistics',
  templateUrl: './installation-statistics.component.html',
  styleUrls: ['./installation-statistics.component.scss']
})
export class InstallationStatisticsComponent implements OnInit {

  @Input() installation !: Installation;
  constructor() { }

  ngOnInit(): void {

  }

}
